var _defs, _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateScenario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 6h16v16h-16z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f36c7}.b{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m0 14c0-7.7 6.3-14 14-14 7.7 0 14 6.3 14 14 0 7.7-6.3 14-14 14-7.7 0-14-6.3-14-14z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m8.4 9.3v7.4c0 0.7 0.3 1.4 0.8 2 0.5 0.5 1.2 0.8 1.9 0.8h7.5c0 0.5-0.2 0.9-0.6 1.3-0.3 0.3-0.8 0.5-1.3 0.5h-8.3c-0.5 0-1-0.2-1.3-0.5-0.4-0.4-0.6-0.8-0.6-1.3v-8.4c0-0.4 0.2-0.9 0.6-1.3 0.3-0.3 0.8-0.5 1.3-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m11.1 18.6c-0.4 0-0.9-0.2-1.3-0.6-0.3-0.3-0.5-0.8-0.5-1.3v-8.3c0-0.5 0.2-1 0.5-1.3 0.4-0.4 0.9-0.6 1.3-0.6h8.4c0.5 0 0.9 0.2 1.3 0.6 0.3 0.3 0.5 0.8 0.5 1.3v8.3c0 0.5-0.2 1-0.5 1.3-0.4 0.4-0.8 0.6-1.3 0.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateScenario);
export default __webpack_public_path__ + "static/media/duplicate-scenario.321a3026ae1839511d47623751fc7666.svg";
export { ForwardRef as ReactComponent };